import React from 'react';
import LegalDocument, { Dato, Enlace, EnlaceExterno } from '../../components/legal/LegalLayout';
import { LEGAL } from '../../config/legalConfig';

const secciones = [
  {
    id: 'titular',
    titulo: 'Titular',
    contenido: (
      <>
        <p>
          {LEGAL.nombreSitio} ({LEGAL.dominio}) es un proyecto personal y sin ánimo de lucro creado y gestionado por{' '}
          <Dato campo="titular" />, el streamer que presenta los concursos en su canal de Twitch. Puedes contactar en{' '}
          <Dato campo="email" />.
        </p>
        <p>
          La web no muestra publicidad ni ofrece productos o servicios de pago. Es una herramienta gratuita para
          preparar y jugar esos concursos.
        </p>
      </>
    ),
  },
  {
    id: 'uso',
    titulo: 'Uso de la web',
    contenido: (
      <p>
        Al usar la web aceptas este aviso. Si además te registras, se aplican las{' '}
        <Enlace to="/condiciones">condiciones de uso</Enlace>, y el tratamiento de tus datos se explica en la{' '}
        <Enlace to="/privacidad">política de privacidad</Enlace>.
      </p>
    ),
  },
  {
    id: 'propiedad',
    titulo: 'Propiedad intelectual',
    contenido: (
      <>
        <p>
          El diseño, el código, el logotipo y los textos propios de la web pertenecen a su titular. No se pueden
          reutilizar con fines comerciales sin permiso.
        </p>
        <p>
          Los nombres, marcas e imágenes de videojuegos, compañías y personajes que aparecen en las preguntas son de
          sus respectivos dueños. Se mencionan solo como referencia en un contexto de entretenimiento, sin relación
          ni patrocinio por su parte.
        </p>
        <p>
          Parte de los iconos de la interfaz son de <EnlaceExterno href="https://www.flaticon.es">Flaticon</EnlaceExterno>{' '}
          (Freepik y otros autores) y se usan con la atribución que exige su licencia.
        </p>
      </>
    ),
  },
  {
    id: 'responsabilidad',
    titulo: 'Contenido y responsabilidad',
    contenido: (
      <>
        <p>
          Las preguntas se revisan antes de publicarse, pero pueden contener errores o quedarse desactualizadas. Si ves
          alguno, avisa por email y se corregirá.
        </p>
        <p>
          Quien envía una pregunta o una imagen responde de ella. Cualquier contenido ilícito del que se tenga
          conocimiento se retirará con rapidez; cómo comunicarlo está en las{' '}
          <Enlace to="/condiciones#denunciar">condiciones de uso</Enlace>.
        </p>
      </>
    ),
  },
  {
    id: 'enlaces',
    titulo: 'Enlaces a otras webs',
    contenido: (
      <p>
        Los enlaces a Twitch, YouTube, X, Instagram o TikTok llevan a servicios de terceros, con sus propias
        condiciones y políticas de privacidad. Su contenido no depende de esta web.
      </p>
    ),
  },
  {
    id: 'ley',
    titulo: 'Ley aplicable',
    contenido: (
      <p>
        Se aplica la legislación española. Si eres consumidor, cualquier conflicto se resolverá en los juzgados de tu
        domicilio.
      </p>
    ),
  },
];

const AvisoLegalPage = () => (
  <LegalDocument
    titulo="Aviso legal"
    intro="Quién está detrás de Diegoncurso y en qué condiciones se ofrece la web."
    secciones={secciones}
  />
);

export default AvisoLegalPage;
